/* Bottomland x Mossy Oak: behaviour for the bl-* sections. Plain JS, no dependencies.
   Guarded so a page with several bl-* sections runs this once. */
(function () {
  if (window.BL) return;
  window.BL = { version: 1 };

  /* Shoppable image: one hotspot open at a time, card shows that product. */
  function initShoppable(stage) {
    var dots = stage.querySelectorAll('.bl-hotspot');
    var cards = stage.querySelectorAll('.bl-wild__card');
    if (!dots.length) return;

    function closeAll() {
      dots.forEach(function (d) { d.setAttribute('aria-expanded', 'false'); });
      cards.forEach(function (c) { c.removeAttribute('data-open'); });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        var open = dot.getAttribute('aria-expanded') === 'true';
        closeAll();
        if (open) return;
        dot.setAttribute('aria-expanded', 'true');
        var card = stage.querySelector('.bl-wild__card[data-for="' + dot.dataset.target + '"]');
        if (card) card.setAttribute('data-open', '');
      });
    });
    cards.forEach(function (card) {
      var close = card.querySelector('.bl-wild__card-close');
      if (close) close.addEventListener('click', closeAll);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

    /* Open the hotspot marked "Open when the page loads" (else the first) so a card shows, as in the comp. */
    (stage.querySelector('.bl-hotspot[data-open-default]') || dots[0]).click();
  }

  function init(root) {
    (root || document).querySelectorAll('.bl-wild__stage').forEach(function (s) {
      if (s.dataset.blReady) return;
      s.dataset.blReady = '1';
      initShoppable(s);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Theme editor re-renders sections; re-bind when that happens. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
